export default __webpack_public_path__ + "static/media/WAY_WHITE.8dbfda34.png";